import React from 'react';
import { shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { toUnit } from '../../../utils/helpers/money';

import { useTypedSelector } from '../../../store';
import { RowMd } from '../../../styles';
import ResultCard from './ResultCard';

const SumUpHeadResults = () => {
  const {
    overallInterestsSum,
    compensationSum,
    finalSum,
    lawsuitOpts,
  } = useTypedSelector(state =>
    state.sumUp, shallowEqual);
  const {
    compensationOn,
    principalAmountOpt,
  } = lawsuitOpts;

  const { t } = useTranslation();

  return (
    <>
      <RowMd gutter={16}>
        {principalAmountOpt !== 'PRINCIPAL_INTEREST' ? (
          <ResultCard
            title={t('sumUpHeadResults.main')}
            value={toUnit(finalSum)}
            compensationOn={compensationOn}
          />
        ) : null}
        <ResultCard
          title={t('sumUpHeadResults.interestOnly')}
          value={toUnit(overallInterestsSum)}
          compensationOn={compensationOn}
        />
        {compensationOn ? (
          <ResultCard
            title={t('sumUpHeadResults.comp')}
            value={toUnit(compensationSum)}
            compensationOn={compensationOn}
          />
        ) : null}
      </RowMd>
    </>
  );
};

export default SumUpHeadResults;